<template>
    <b-modal
        size="lg"
        v-model="mostrarModal"
        no-close-on-backdrop
        @close="fecharModal()"
        @show="preencher()">
        <div slot="modal-title">
            Aditivo -
            <b-badge variant="warning">{{ operacao }}</b-badge>
        </div>
        <app-erros-box :erros="erros" v-if="erros.length > 0"></app-erros-box>
        <b-row>
            <b-col sm="12" md="6">
                <b-form-group>
                    <label for="tipoAditivo">Tipo Aditivo</label>
                    <b-input-group>
                        <b-form-select
                            id="tipoAditivo"
                            type="text"
                            :options="tipoAditivo"
                            value-field="key"
                            text-field="label"
                            v-model="aditivo.tipoAditivo"
                            :disabled='atualizar'
                            >
                        </b-form-select>
                        <b-form-invalid-feedback>Tipo do Aditivo é obrigatório</b-form-invalid-feedback>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="12" md="12">
                <b-form-group>
                    <label for="objeto">Objeto</label>
                    <b-input-group>
                        <b-form-textarea
                            id="objeto"
                            type="text"
                            v-model="objeto"
                            placeholder="Objeto"
                            :rows="4"
                            @input.native="$v.objeto.$touch()"
                            :state="$v.objeto.$error ? false : null"
                        ></b-form-textarea>
                        <b-form-invalid-feedback>Objeto é obrigatório</b-form-invalid-feedback>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="12" md="3">
                <b-form-group
                    v-if="exibeData"
                    :state="$v.dataProrrogada.$error ? false : null"
                    invalid-feedback="Data é obrigatória">
                    <label for="dataProrrogada">Data Prorrogação</label>
                    <b-input-group>
                        <date-picker
                            v-model="dataProrrogada"
                            :config="$datePickerOptions"
                            v-mask="'##/##/####'"
                            @input.native="$v.dataProrrogada.$touch()"
                        ></date-picker>
                    </b-input-group>
                </b-form-group>

                <b-form-group v-if="exibeValor">
                    <label for="valorAditivo">Valor do Aditivo</label>
                    <b-input-group>
                        <money
                                id="valorAditivo"
                                v-model="valor"
                                v-bind="money"
                                class="form-control text-right"
                                @input.native="$v.valor.$touch()"
                                :state="
                                    $v.valor.$error
                                        ? false
                                        : null
                                "
                        ></money>
                        <b-form-invalid-feedback>Valor Aditivo Obrigatório</b-form-invalid-feedback>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>
        <div slot="modal-footer">
            <b-button variant="secondary" @click.stop="fecharModal()">
                Cancelar
            </b-button>
            <b-button
                variant="primary"
                :disabled="this.$v.$invalid"
                @click.stop="salvar()"
                class="ml-1">
                Salvar
            </b-button>
        </div>
    </b-modal>
</template>

<script>

import { required, minValue } from 'vuelidate/lib/validators'

export default {
    props: {
        convenio: Object,
        aditivo: Object,
        operacaoProp: String,
        mostrarModal: {
            type: Boolean,
            default: () => false
        },
        erros: {
            type: Array,
            default: () => []
        }
    },

    validations: {
        valor: {
            valorOk() {
                if (this.aditivo.tipoAditivo == 2) {
                    return this.valor && this.valor > 0
                }
                return true
            }
        },
        objeto: {
            required
        },

        dataProrrogada: {
            dataOk(){
                if (this.aditivo.tipoAditivo == 1){
                    return this.dataProrrogada && this.dataProrrogada != null && this.dataProrrogada != ''
                }
                return true
            }
        },
    },

    data() {
        return {
            objeto: null,
            valor: 0,
            dataProrrogada: '',

            exibeValor: false,
            exibeData: true,
            mostrarModal: false,
            erros: [],
            atualizar: false,
            money: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                suffix: '',
                precision: 2,
                masked: false,
            },
            tipoAditivo: [
                {
                    key: '1',
                    label: 'Prorrogação de Data',
                },
                {
                    key: '2',
                    label: 'Adição de Valor',
                }
            ],
            aditivo: {
                idConvenio:0,
                // idAditivo:0,
                dataAditivo:null,
                objeto:'',
                tipoAditivo:1,
                dataProrrogada:null,
                valorAditivo:0,
                statusAditivo:1
            },
        }
    },

    computed: {
        operacao() {
            if (this.operacaoProp == 'I') {
                return 'INCLUSÃO'
            }
            return 'ATUALIZAÇÃO'
        }
    },

    methods: {
        preencher() {
            if (this.operacaoProp == 'A') {
                if(this.aditivo.tipoAditivo == 1){
                    this.aditivo.idAditivo = this.aditivo.idAditivo
                    this.aditivo.tipoAditivo = this.aditivo.tipoAditivo
                    this.dataProrrogada = this.$moment(this.aditivo.dataProrrogada).format('DD/MM/YYYY')
                    this.valorAditivo = this.aditivo.valor
                    this.objeto = this.aditivo.objeto
                    this.valorAditivo = this.aditivo.valorAditivo
                    this.statusAditivo = this.aditivo.statusAditivo
                    this.atualizar = true
                    this.exibeValor = false
                    this.exibeData = true
                } else if (this.aditivo.tipoAditivo == 2){
                    this.aditivo.idAditivo = this.aditivo.idAditivo
                    this.aditivo.tipoAditivo = this.aditivo.tipoAditivo
                    this.dataProrrogada = this.$moment(this.aditivo.dataProrrogada).format('DD/MM/YYYY')
                    this.valor = this.aditivo.valorAditivo
                    this.objeto = this.aditivo.objeto
                    this.valorAditivo = this.aditivo.valorAditivo
                    this.statusAditivo = this.aditivo.statusAditivo
                    this.atualizar = true
                    this.exibeValor = true
                    this.exibeData = false
                }
            } else {
                this.dataAditivo = new Date()
            }
        },

        fecharModal() {
            this.$emit('fechar')
            this.resetar()
        },

        resetar(){
            this.aditivo.idConvenio = this.convenio.idConvenio
            //this.aditivo.idAditivo = 0
            this.aditivo.dataAditivo = new Date()
            this.aditivo.objeto = ""
            this.aditivo.tipoAditivo = 1
            this.aditivo.dataProrrogada = new Date()
            this.aditivo.valorAditivo=0
            this.aditivo.statusAditivo=1
            this.objeto= null
            this.valor= 0
            this.dataProrrogada= ''
            this.erros= []
            this.atualizar = false
        },

        salvar(aditivo) {
            this.aditivo.dataProrrogada = this.dataProrrogada
            this.aditivo.objeto = this.objeto
            this.aditivo.valorAditivo = this.valor
            this.aditivo.dataAditivo = this.dataAditivo
            aditivo = this.aditivo
            this.$emit('salvar', aditivo)
            this.resetar()
        },
    },

    watch: {
        'aditivo.tipoAditivo'(){
            if(this.aditivo.tipoAditivo){
                if(this.aditivo.tipoAditivo == 1){
                    this.exibeValor = false
                    this.exibeData = true
                }
                else if(this.aditivo.tipoAditivo == 2){
                    this.exibeValor = true
                    this.exibeData = false
                }
            }
        }
    }
}
</script>
